import { render, staticRenderFns } from "./instAgreement_easyconfirm.vue?vue&type=template&id=4f0a666c&scoped=true"
import script from "./instAgreement_easyconfirm.vue?vue&type=script&lang=js"
export * from "./instAgreement_easyconfirm.vue?vue&type=script&lang=js"
import style0 from "./instAgreement_easyconfirm.vue?vue&type=style&index=0&id=4f0a666c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a666c",
  null
  
)

export default component.exports